import {Component, OnInit} from '@angular/core';
import {HttpStatusCode} from "@angular/common/http";
import {LocalStorageKey} from "projects/store/src/app/enums";
import {Router} from "@angular/router";
import {AuthService} from "projects/store/src/app/services/api/v1/auth.service";
import {PermissionService} from "projects/store/src/app/services/permission.service";
import {CustomMessageService, LocalStorageService, UtilService, ResponseHttpError, ResponseHttpSuccess} from "library";

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html'
})
export class LogoutComponent implements OnInit {
  constructor(private router: Router,
              private authService: AuthService,
              private utilService: UtilService,
              private localStorageService: LocalStorageService,
              private permissionService: PermissionService,
              private customMessageService: CustomMessageService) { }

  ngOnInit() {
    this.logout()
  }

  logout() {
    this.utilService.enablePageLoading();
    this.authService.logout().subscribe({
      next: (resp: ResponseHttpSuccess)=> {
        if(resp.status === HttpStatusCode.Ok) {
          this.localStorageService.remove(LocalStorageKey.token);
          this.localStorageService.remove(LocalStorageKey.data);

          this.authService.authenticationNext(false);
          this.utilService.disablePageLoading();
          this.router.navigate(['login']);
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.utilService.disablePageLoading();
      },
      error: (error: ResponseHttpError) => {
        this.customMessageService.responseNoticeHandler(error);
        this.utilService.disablePageLoading();
      }
    });

  }
}
